import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';
import { WORKFLOW_STEPS } from '~/containers/viewer/explorer-sidebar/WorkflowStepper/workflow-steps';
import {
    selectedOperationState,
    selectedToolState,
} from '~/state/atoms/toolsAtoms';

export default function WorkflowSidebarContent() {
    const setSelectedTool = useSetRecoilState(selectedToolState);
    const setSelectedOperation = useSetRecoilState(selectedOperationState);
    const { currentStep } = useWorkflowSteps();

    const resolvedStep = currentStep ?? WORKFLOW_STEPS[0];

    useEffect(() => {
        setSelectedTool('pan');
        setSelectedOperation(null);
    }, [resolvedStep, setSelectedTool, setSelectedOperation]);

    const ContentComponent = resolvedStep.content;

    return <ContentComponent />;
}
